import { NavLink } from 'react-router-dom'
import { cn } from '@/utils/cn'
import {
  ChatBubbleIcon,
  MagnifyingGlassIcon,
  UserGroupIcon,
  BeakerIcon,
  BookOpenIcon,
  TargetIcon,
  ShieldCheckIcon,
} from '@/components/icons/Icons'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

export function Sidebar() {
  const { show_eval_runs, show_prompt_lab } = useFeatureFlags()

  const navItems = [
    { to: '/', label: 'Conversations', icon: ChatBubbleIcon },
    { to: '/search', label: 'Search', icon: MagnifyingGlassIcon },
    { to: '/personas', label: 'Personas', icon: UserGroupIcon },
    ...(show_eval_runs
      ? [{ to: '/eval-runs', label: 'Eval Runs', icon: TargetIcon }]
      : []),
    ...(show_prompt_lab
      ? [{ to: '/prompt-lab', label: 'Prompt Lab', icon: BeakerIcon }]
      : []),
    { to: '/knowledge', label: 'Knowledge', icon: BookOpenIcon },
    { to: '/knowledge-query', label: 'KB Query', icon: TargetIcon },
    { to: '/governor', label: 'Governor', icon: ShieldCheckIcon },
  ]

  return (
    <aside className="flex w-64 flex-col border-r border-gray-200 bg-gray-50">
      <div className="flex h-16 items-center border-b border-gray-200 px-6">
        <span className="text-lg font-semibold text-primary-600">Member Chat</span>
      </div>

      <nav className="flex-1 p-4">
        <ul className="space-y-1">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'border-l-4 border-primary-600 text-primary-700'
                      : 'text-gray-700 hover:bg-gray-100'
                  )
                }
              >
                <item.icon className="h-5 w-5 shrink-0" />
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  )
}
